var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.articleExists)?_c('a',{staticClass:"product-link-room",attrs:{"href":_vm.designerUrl,"target":"_blank"}},[_vm._v("\n  Im Raum ansehen\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }